var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.71,12.44H12.43V22h7.28A2.29,2.29,0,0,0,22,19.72V12.44H19.71Zm.2,7.28a.2.2,0,0,1-.2.2h-5a.2.2,0,0,1-.2-.2v-.35h0V15.06h0v-.34a.2.2,0,0,1,.2-.2h5a.2.2,0,0,1,.2.2v.34h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.71,2H4.29A2.3,2.3,0,0,0,2,4.29v7.34H22V4.29A2.3,2.3,0,0,0,19.71,2Zm.2,7.33a.2.2,0,0,1-.2.21H4.29a.2.2,0,0,1-.2-.21v-5a.2.2,0,0,1,.2-.2H19.71a.2.2,0,0,1,.2.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,12.44H2v7.28A2.28,2.28,0,0,0,4.28,22h7.29V12.44H9.28Zm.2,6.93h0v.35a.2.2,0,0,1-.2.2h-5a.2.2,0,0,1-.2-.2V15.06h0v-.34a.21.21,0,0,1,.2-.2h5a.2.2,0,0,1,.2.2v.34h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerView);
export default __webpack_public_path__ + "static/media/speaker-view.85215ff7b9c97ee8d0c2869b97165a13.svg";
export { ForwardRef as ReactComponent };